import { render, staticRenderFns } from "./MyNothing.vue?vue&type=template&id=590c4e26&scoped=true&"
import script from "./MyNothing.vue?vue&type=script&lang=js&"
export * from "./MyNothing.vue?vue&type=script&lang=js&"
import style0 from "./MyNothing.vue?vue&type=style&index=0&id=590c4e26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590c4e26",
  null
  
)

export default component.exports